import { AbstractModel } from "@gipi-pages/abstract/models/abstract.model";
import { GIPIUuid } from "@gipi-shared/types/uuid.type";
import { UUIDUtil } from "@gipi-ui/utils/uuid.util";

export class ClientClassificationModel extends AbstractModel {

    description: string;

    financialMessage: string;

    financialObservation: string;

    constructor(id?: GIPIUuid) {
        super();
        if (UUIDUtil.isValid(id)) {
            this.id = id;
        }
    }

}
